module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/allclass_active-bf5be579ccc9562bc65cc68d8e48eafd.png";